import { notification } from "antd";

const getNotificationMessage = (text: unknown, fallback: string): string => {
  if (text === undefined || text === null) {
    return fallback;
  }

  if (typeof text === "string" || typeof text === "number" || typeof text === "boolean") {
    return String(text);
  }

  if (Array.isArray(text)) {
    const joined: string = text
      .map((item: unknown): string => getNotificationMessage(item, ""))
      .filter((item: string): boolean => Boolean(item))
      .join(", ");
    return joined || fallback;
  }

  const objectText = text as any;
  const objectMessage =
    objectText?.message ??
    objectText?.error?.messages?.[0] ??
    objectText?.warnings?.[0] ??
    objectText?.warning ??
    objectText?.title;

  if (objectMessage !== undefined && objectMessage !== null) {
    return getNotificationMessage(objectMessage, fallback);
  }

  try {
    const jsonText = JSON.stringify(text);
    return jsonText === "{}" ? fallback : jsonText;
  } catch {
    return fallback;
  }
};

export const setNotificationsConfig = () => {
  notification.config({
    top: 50,
    duration: 2,
    maxCount: 1,
  });
};

export const showSuccessNotification = (text = "Updated successfully") => {
  const message = getNotificationMessage(text, "Updated successfully");
  notification.success({
    key: "success",
    type: "success",
    message,
    placement: "topRight",
  });
};

export const showErrorNotification = (text?: any, e?: any) => {
  const message = getNotificationMessage(
    text,
    "Something went wrong, please try again"
  );

  if (e?.response?.status === 401) {
    notification.error({
      key: "error401",
      message: "Error",
      description: "Your session has expired, please re-log in",
      duration: 0,
    });
  } else if (e?.response?.status === 404) {
    notification.error({
      key: "error404",
      type: "error",
      message,
      placement: "topRight",
    });
  } else if (e?.response?.status === 500) {
    notification.error({
      key: "error500",
      type: "error",
      message,
      placement: "topRight",
    });
  } else if (e?.response?.status === 400) {
    notification.error({
      key: "error400",
      type: "error",
      message,
      placement: "topRight",
    });
  } else {
    notification.error({
      key: "error",
      type: "error",
      message,
      placement: "topRight",
    });
  }
};

export const showWarningNotification = (text = "") => {
  notification.warning({
    key: "warning",
    type: "warning",
    message: text,
    duration: 0,
    placement: "topRight",
  });
};
